<template>
  <v-col cols="12">
    <a :href="teaserItem.url">
      <div class="menu-teaser">
        <v-img
          :src="teaserItem.image"
          width="100%"
          height="100%"
        />

        <div class="menu-teaser__hover">
          <v-btn
            outlined
            tile
            color="#fff"
            class="menu-teaser__button"
          >
            {{ $t('messages.know-more') }}
          </v-btn>
        </div>

        <div class="menu-teaser__body">
          <h3 v-if="teaserItem.suptitle" class="menu-teaser__suptitle">{{ teaserItem.suptitle }}</h3>
          <h2 class="menu-teaser__title">{{ teaserItem.title }}</h2>

          <p class="menu-taser__content">{{ content }}</p>
        </div>
      </div>
    </a>
  </v-col>
</template>

<script>
  export default {
    name: 'TheMenuTeaser',
    props: {
      teaserItem: {
        required: true,
      },
    },

    computed: {
      content() {
        const sliced = this.teaserItem.content.slice(0, 70)

        return `${sliced}...`
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  a
    color: #000 !important

  .menu-teaser
    height: 280px
    position: relative

    &__body
      position: absolute
      right: 0
      bottom: 0
      left: 0
      text-align: left
      padding: 20px

    &__title
      margin-bottom: 10px

    &__suptitle
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 10px

    &__hover
      opacity: 0
      position: absolute
      z-index: 1
      top: 0
      left: 0
      width: 100%
      height: 100%
      transition: opacity 0.4s
      background-color: $primary-color
      display: flex
      align-items: center
      justify-content: center
      color: #fff

    &:hover .menu-teaser__hover
      opacity: 1

  @media (max-width: 1263px)
    .menu-teaser
      height: 43vh

  ::v-deep .v-image__image--cover:before
    content: ""
    display: block
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 35%, rgba(255, 255, 255, 0.47) 52%, #fff 99%)
</style>
